import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

export default function EditPromptModal({ prompt, isOpen, onClose, onSubmit }) {
  const [form, setForm] = useState({ name: "", content: "" });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (isOpen && prompt) {
      setForm({
        name: prompt.name || "",
        content: prompt.content || "",
      });

      // Add a tiny delay to ensure ReactQuill registers the update
      setTimeout(() => {
        setIsReady(true);
      }, 50);
    } else {
      setIsReady(false);
    }
  }, [isOpen, prompt]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleEditorChange = (content) => {
    setForm((prev) => ({ ...prev, content }));
    if (errors.content) {
      setErrors((prev) => ({ ...prev, content: "" }));
    }
  };

  const handleSubmit = async () => {
    const validationErrors = {};
    if (!form.name.trim()) validationErrors.name = "Name is required";
    if (form.content.trim().length <= 11) validationErrors.content = "Content is required";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const editData = {...form, id: prompt.id};

    setIsSubmitting(true);
    try {
      await onSubmit(editData);
      onClose();
    } catch (error) {
      console.error("Submit failed:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-[50%] max-h-[70vh] overflow-y-auto shadow-lg ">
        <h2 className="text-xl font-semibold mb-4">Edit Prompt</h2>

        <div className="mb-4">
          <label className="block text-sm font-medium">Name <span className="italic text-xs text-gray-600">can't edit prompt name</span></label>
          <input
            name="name"
            disabled 
            value={form.name}
            onChange={handleChange}
            className="w-full mt-1 p-2 border border-gray-300 rounded"
            placeholder="Enter prompt name"
          />
          {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium mb-1">Content</label>
          <div className={errors.content ? "border border-red-500 rounded" : ""}>
            {isReady && (
              <ReactQuill
                defaultValue={form.content}
                onChange={handleEditorChange}
                className="mb-4"
              />
            )}
          </div>
          {errors.content && (
            <p className="text-sm text-red-600 mt-1">{errors.content}</p>
          )}
          <p className="text-xs text-gray-500 mt-2">
            Use the formatting toolbar to style your content.
          </p>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-brandPrimary text-white rounded"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}


